// src/components/LoginForm.js
import React, { useState } from 'react';

const LoginForm = ({ onLogin, apiUrl }) => {
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginForm)
      });

      if (!response.ok) {
        const error = await response.json();
        setLoginError(error.error || 'Identifiants invalides');
        setLoading(false);
        return;
      }

      const data = await response.json();
      onLogin(data.token, data.user);
      setLoginForm({ email: '', password: '' });
    } catch (error) {
      setLoginError('Erreur de connexion au serveur');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>🔐 Backoffice SAV</h1>
          <p>Connectez-vous pour accéder au panneau d'administration</p>
        </div>
        
        <form onSubmit={handleLogin} className="login-form">
          {loginError && (
            <div className="login-error">
              {loginError}
            </div>
          )}
          
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={loginForm.email}
              onChange={(e) => setLoginForm({...loginForm, email: e.target.value})}
              placeholder="admin@example.com"
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              value={loginForm.password}
              onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>
          
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
        
        <div className="login-demo">
          <p><strong>Comptes de démonstration :</strong></p>
          <ul>
            <li>Admin: admin@example.com / admin123</li>
            <li>Éditeur: editor@example.com / editor123</li>
            <li>Lecteur: reader@example.com / reader123</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;